import React, { useId } from "react";
import { usePmsTheme } from "../../../Components/PmsThemeContext";
import { getDocumentTranslator } from "./documentPopupMessages";
import {
  requisitionCanonicalQuantity, requisitionDisplayQuantity, requisitionQuantityError,
  requisitionUnitOptions, selectedRequisitionUnit,
} from "../../utils/requisitionUnits";
import "./RequisitionUnitFields.css";

export function RequisitionQuantityInput({ line, item, units, onChange, onBlur, className }) {
  const { languageId } = usePmsTheme();
  const t = getDocumentTranslator(languageId);
  const errorId = useId();
  const option = selectedRequisitionUnit(line, item, units, languageId);
  const error = requisitionQuantityError(line, item, units, languageId, t);
  return <>
    <input type="number" step="any" className={className}
      aria-label={`${t("Qty")} (${option?.label || t("Packaging")})`}
      aria-invalid={Boolean(error)} aria-describedby={error ? errorId : undefined}
      value={requisitionDisplayQuantity(line, option)}
      onChange={(event) => onChange(requisitionCanonicalQuantity(event.target.value, option))}
      onBlur={onBlur} />
    {error && <div id={errorId} role="alert" style={{ color: "var(--pu-danger)", fontSize: ".75rem", marginTop: 6 }}>{error}</div>}
  </>;
}

export function RequisitionUnitPicker({ line, item, units, onChange }) {
  const { languageId } = usePmsTheme();
  const t = getDocumentTranslator(languageId);
  const options = requisitionUnitOptions(line, item, units, languageId);
  const selected = selectedRequisitionUnit(line, item, units, languageId);
  const format = (number) => number.toLocaleString(languageId === "es" ? "es-ES" : "en-GB", { maximumFractionDigits: 8 });
  if (!line.item_id || !options.length) return <span>{selected?.label || "-"}</span>;
  return <>
    <div className="rq-unitPicker" role="group" aria-label={t("Packaging")}>
      {options.map((option) => <button type="button" key={option.level}
        className="rq-unitChoice" title={option.label} aria-pressed={selected?.level === option.level}
        onClick={() => { if (selected?.level !== option.level) onChange(option.level); }}>
        {option.label}
      </button>)}
    </div>
    {options.length > 1 && <small className="rq-unitRelation">{`1 ${options[0].label} = ${format(options[options.length - 1].factor)} ${options[options.length - 1].label}`}</small>}
  </>;
}
